import { render, staticRenderFns } from "./comeBeautiful.vue?vue&type=template&id=47acf68a&scoped=true"
import script from "./comeBeautiful.vue?vue&type=script&lang=js"
export * from "./comeBeautiful.vue?vue&type=script&lang=js"
import style0 from "./comeBeautiful.vue?vue&type=style&index=0&id=47acf68a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47acf68a",
  null
  
)

export default component.exports